export default __webpack_public_path__ + "static/media/UchaIcon.46666ea2.svg";